import { render, staticRenderFns } from "./D002.vue?vue&type=template&id=68a95052&scoped=true&"
import script from "./D002.vue?vue&type=script&lang=js&"
export * from "./D002.vue?vue&type=script&lang=js&"
import style0 from "./D002.vue?vue&type=style&index=0&id=68a95052&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a95052",
  null
  
)

export default component.exports